import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { values } from 'ramda';

import {
  DURATION,
  EYE,
  FREQUENCY,
  ID,
  SUB_DRUG,
  SUB_PATIENT,
  useAlerts,
  useMedicalHistoryActions,
  useMedications,
  VALID_FROM,
  VALID_TO,
} from 'store/medicalHistory';

export const usePatientMedications = () => {
  const { id } = useParams();
  const { createMedication, removeMedication } = useMedicalHistoryActions();
  const medications = useMedications();
  const medicationList = useMemo(() => values(medications), [medications]);
  const createAlerts = useAlerts(createMedication);
  const removeAlerts = useAlerts(removeMedication);
  const [drugComparator, patientDrugList] = useMemo(
    () =>
      medicationList.reduce(
        (acc, { [ID]: medId, [SUB_DRUG]: drug }) => [{ ...acc[0], [drug[ID]]: medId }, [...acc[1], drug]],
        [{}, []]
      ),
    [medicationList]
  );
  const [onAdd, onRemove] = [createAlerts.action, removeAlerts.action];

  return {
    list: medicationList,
    drugComparator,
    patientDrugList,
    editLoading: createAlerts.loading || removeAlerts.loading,
    addMedication: useCallback(
      (drug) =>
        onAdd({
          [SUB_PATIENT]: id,
          [SUB_DRUG]: drug[ID],
          [EYE]: null,
          [FREQUENCY]: null,
          [DURATION]: null,
          [VALID_FROM]: null,
          [VALID_TO]: null,
        }),
      [onAdd, id]
    ),
    removeMedication: useCallback((medId) => onRemove(medId), [onRemove]),
  };
};
